import { Flex } from '@chakra-ui/react';
import React from 'react';
import { PATHS } from '../../router/routes';

const MainContainer = ({ children, title, ...props }) => {
    return (
        <Flex
            justifyContent='center'
            alignItems={{
                base: title === 'stepper' ? 'flex-start' : 'center',
                md: 'center',
                lg: 'center',
                xl: 'center',
            }}
            h={{ base: 'auto', sm: title === PATHS.SIGN_UP ? 'auto' : '100vh' }}
            p={{ base: '10px', sm: title === PATHS.SIGN_UP ? '80px 0px 0px 0px' : '0px' }}
            width='100%'
            {...props}
        >
            {children}
        </Flex>
    );
};

export default MainContainer;
